import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  padding: ${spacing('xl3')} ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl5')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
`;

export const StyledHeader = styled.div`
  padding-bottom: ${spacing('xl2')};
  border-bottom: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
  }

  > div {
    max-width: ${container('md')};
  }
`;

export const StyledDesc = styled.p`
  color: ${color('text_subtle')};
`;

export const StyledSubsection = styled.div`
  padding-top: ${spacing('xl2')};
  padding-bottom: ${spacing('xl2')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  border-bottom: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl4')};
  }
`;

export const StyledSubsectionHeader = styled.div`
  h5 {
    color: ${color('text_subtle')};
    font-size: ${fontSize('lg')};
    line-height: 1.2;
    font-weight: ${fontWeight('extraBold')};
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.35em;
  }
  p {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }
`;

export const StyledChart = styled.div`
  flex-shrink: 0;
  max-width: 23.5rem;
`;

export const StyledFooter = styled.p`
  color: ${color('text_subtle')};
  margin-top: ${spacing('xl2')};
`;
